/* eslint-disable import/no-anonymous-default-export */
export default {
  isProduction: false,
  baseURL: {
    fineract: {
      dev: process.env.REACT_APP_BASE_URL_DEVELOPMENT,
      prod: process.env.REACT_APP_BASE_URL_PRODUCTION,
    },
    treasury: {
      dev: process.env.REACT_APP_TREASURY_BASE_URL_DEVELOPMENT,
      prod: process.env.REACT_APP_TREASURY_BASE_URL_PRODUCTION,
    },
    teller: {
      dev: process.env.REACT_APP_TELLER_BASE_URL_DEVELOPMENT,
      prod: process.env.REACT_APP_TELLER_BASE_URL_PRODUCTION,
    },
    wallet: {
      dev: process.env.REACT_APP_WALLET_BASE_URL_DEVELOPMENT,
      prod: process.env.REACT_APP_WALLET_BASE_URL_PRODUCTION,
    },
  },
  apiSettings: {
    headers: {
      "Finsys-Platform-TenantId":
        process.env.REACT_APP_HEADER_FINSYSCORE_PLATFORM_TENANT_ID,
      Authorization: process.env.REACT_APP_HEADER_AUTHORIZATION,
    },
  },
};
